import { FC } from "react";
import { useAppSelector } from "../../../../../../../../../../../store/hooks";
import { TotalCostColumnHeaderCell } from "../../../../../../../../../resource-explorer/components/resource-explorer-card/components/resource-explorer-data-grid/components/columns/components/common/TotalCostColumnHeaderCell";
import { costBreakdownV2WidgetTotalCostSelector } from "../../../../../../../../../../../store/dashboards/selectors/widgets/cost-breakdown-v2/widget-view/costBreakdownV2WidgetTotalCostSelector";

interface CostBreakdownWidgetTableTotalCostHeaderCellProps {
  widgetId: string;
}
export const CostBreakdownV2WidgetTableTotalCostHeaderCell: FC<
  CostBreakdownWidgetTableTotalCostHeaderCellProps
> = ({ widgetId }) => {
  const total = useAppSelector((state) =>
    costBreakdownV2WidgetTotalCostSelector(state, widgetId),
  );

  return (
    <TotalCostColumnHeaderCell
      totalCost={total?.cost ?? 0}
      dateDetails={total?.dateDetails}
    />
  );
};
